import get from "lodash/get";
import React, { Fragment } from "react";
import Ingredients from "./Ingredients";
import "./recipe.m.css";

function Metadata({ story }) {
  const storyAttributes = get(story, ["metadata", "story-attributes"]);
  const servings = get(story, ["metadata", "servings"], "");

  const cookInfo = [
    { label: "Cuisine:", value: storyAttributes?.cuisine?.[0] },
    { label: "Cook time:", value: storyAttributes?.cookingtime?.[0] },
    { label: "Prep time:", value: storyAttributes?.preparationtime?.[0] },
    { label: "Servings:", value: servings },
  ];

  return (
    <div styleName="recipe-attributes">
      {cookInfo.map((item) => (
        <div key={item.label}>
          <span>{item?.label}</span>
          <span>{item?.value}</span>
        </div>
      ))}
    </div>
  );
}

export default function RecipeDetails({ story, adsConfig, template, articleApi }) {
  const ingredients = get(story, ["metadata", "ingredients"], "");
  return (
    <Fragment>
      <Metadata story={story} />
      <Ingredients ingredients={ingredients} />
    </Fragment>
  );
}
